import * as React from 'react';

const pen = (props: any) => {
  const { colorPrimary, colorSecondary } = props;

  return (
    <>
      <g fill="none" fillRule="evenodd">
        <path
          d="M48.0001 89H93.0001M70.5001 6.12088C72.4891 4.12259 75.1871 3 78.0001 3C79.3931 3 80.7721 3.27561 82.0591 3.81106C83.3461 4.34656 84.5151 5.1314 85.5001 6.12088C86.4851 7.11031 87.2661 8.28493 87.7991 9.5777C88.3326 10.8705 88.6066 12.2561 88.6066 13.6554C88.6066 15.0546 88.3326 16.4402 87.7991 17.733C87.2661 19.0257 86.4851 20.2004 85.5001 21.1898L23.0001 83.977L3.00006 89L8.00006 68.9081L70.5001 6.12088Z"
          stroke={colorPrimary}
          strokeWidth="6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </>
  );
};
export default pen;
